<!-- User -->
@if (apps_datas) {
  <!-- Render visible apps -->
  <ng-container *ngFor="let apps_data of apps_datas; let i = index">
    <ng-container *ngIf="appHelperService.getAppConfig(apps_data)?.visibility">
      <div [ngClass]="settings?.size === 'large' ? 'pb-4' : ''">
        <div class="relative w-full" [ngClass]="settings?.size === 'large' ? 'box' : 'text-xs'">
          <div class="flex items-center mb-3">
            <span *ngIf="settings?.icon" class="flex text-primary mr-3">
              <mat-icon>{{ appHelperService.getAppConfig(apps_data)?.icon }}</mat-icon>
            </span>
            <a
              *ngIf="settings?.title"
              class="font-bold streched-link"
              [routerLink]="appHelperService.getAppConfig(apps_data)?.app_url">
              {{ appHelperService.getAppConfig(apps_data)?.app_brand_name | translate }}
            </a>
          </div>
          <div *ngIf="settings?.description" class="text-gray text-sm">
            {{ appHelperService.getAppConfig(apps_data)?.app_brand_short_desc | translate }}
          </div>
          <div *ngIf="settings?.arrow" class="flex flex-row-reverse bottom-icon-holder">
            <i class="pi pi-arrow-right pi-link-icon"></i>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- Render "Coming Soon" apps -->
  <ng-container *ngFor="let apps_data of apps_datas; let i = index">
    <ng-container *ngIf="!appHelperService.getAppConfig(apps_data)?.visibility">
      <div *ngIf="settings?.comingsoon" [ngClass]="settings?.size === 'large' ? 'pb-4' : ''">
        <div
          class="box-disabled relative w-full"
          [ngClass]="settings?.size === 'large' ? 'box' : 'text-xs'">
          <div class="flex items-center mb-3">
            <span *ngIf="settings?.icon" class="flex text-primary mr-3">
              <mat-icon>{{ appHelperService.getAppConfig(apps_data)?.icon }}</mat-icon>
            </span>
            <span *ngIf="settings?.title" class="font-bold opacity-50">
              {{ appHelperService.getAppConfig(apps_data)?.app_brand_name | translate }}
            </span>
          </div>
          <div *ngIf="settings?.description" class="text-gray text-sm">
            {{ appHelperService.getAppConfig(apps_data)?.app_brand_short_desc | translate }}
          </div>
          <div class="caption primary">
            {{ 'Coming soon' | translate }}
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
}

<!-- Business -->

@if (app_infos.length > 0) {
  <ng-container *ngFor="let app_info of app_infos; let i = index">
    <ng-container *ngIf="app_info?.visibility">
      <div [ngClass]="settings?.size === 'large' ? 'pb-4' : ''">
        <div class="relative w-full" [ngClass]="settings?.size === 'large' ? 'box' : 'text-xs'">
          <div class="flex items-center mb-3">
            <span *ngIf="settings?.icon" class="flex text-primary mr-3">
              <mat-icon>{{ app_info?.icon }}</mat-icon>
            </span>
            <a
              *ngIf="settings?.title"
              class="font-bold streched-link"
              [routerLink]="getErpUrl(app_info?.url)">
              {{ app_info?.name | translate }}
            </a>
          </div>
          <div *ngIf="settings?.description" class="text-gray text-sm">
            {{ app_info?.short_desc | translate }}
          </div>
          <div *ngIf="settings?.arrow" class="flex flex-row-reverse bottom-icon-holder">
            <i class="pi pi-arrow-right pi-link-icon"></i>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
}
